import { render, staticRenderFns } from "./AboutUsQuickButtons.vue?vue&type=template&id=ee69918c&"
import script from "./AboutUsQuickButtons.vue?vue&type=script&lang=js&"
export * from "./AboutUsQuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee69918c')) {
      api.createRecord('ee69918c', component.options)
    } else {
      api.reload('ee69918c', component.options)
    }
    module.hot.accept("./AboutUsQuickButtons.vue?vue&type=template&id=ee69918c&", function () {
      api.rerender('ee69918c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/sitecontent/AboutUsQuickButtons.vue"
export default component.exports